// extracted by mini-css-extract-plugin
export default {"statsSection":"StatsNumber_statsSection__+KKWL","boxes":"StatsNumber_boxes__7ZTxN"};